import React, { Component } from "react";
import { connect } from "react-redux";
import Button from "@material-ui/core/Button";
import "react-loader-spinner/dist/loader/css/react-spinner-loader.css";
import "./Emco_Region_Table_Row.scss";
import translator from "../../../utils/translator";

export class Emco_Region_Table_Row extends Component {
	render() {
		return (
			<React.Fragment>
				<tr>
					<td>
						<input
							type="text"
							class="form-control settings-form region-setting-form"
							placeholder={translator("Admin Regions", "region_label")}
							defaultValue={this.props.location_title}
							onBlur={e =>
								this.props.modify_region(
									this.props.emco_region_table_row_index,
									{
										id: this.props.emco_region_ID,
										location_title: e.target.value,
										id_prod: this.props.id_prod,
										"id_dev-istrain": this.props["id_dev-istrain"],
										id_dev: this.props.id_dev
									},
									"location_title"
								)
							}
						/>
					</td>
					<td>
						<input
							type="text"
							class="form-control settings-form region-setting-form"
							placeholder={translator("Admin Project Delete", "server_prod") + " ID"}
							defaultValue={this.props.id_prod}
							onBlur={e =>
								this.props.modify_region(
									this.props.emco_region_table_row_index,
									{
										id: this.props.emco_region_ID,
										location_title: this.props.location_title,
										id_prod: e.target.value,
										"id_dev-istrain": this.props["id_dev-istrain"],
										id_dev: this.props.id_dev
									},
									"id_prod"
								)
							}
						/>
					</td>
					<td>
						<input
							type="text"
							class="form-control settings-form region-setting-form"
							placeholder={translator("Admin Regions", "staging_label") + " ID"}
							defaultValue={this.props.id_dev_isTrain}
							onBlur={e =>
								this.props.modify_region(
									this.props.emco_region_table_row_index,
									{
										id: this.props.emco_region_ID,
										location_title: this.props.location_title,
										id_prod: this.props.id_prod,
										"id_dev-istrain": e.target.value,
										id_dev: this.props.id_dev
									},
									"id_dev-istrain"
								)
							}
						/>
					</td>
					<td>
						<input
							type="text"
							class="form-control settings-form region-setting-form"
							placeholder={translator("Admin Project Delete", "server_dev") + " ID"}
							defaultValue={this.props.id_dev}
							onBlur={e =>
								this.props.modify_region(
									this.props.emco_region_table_row_index,
									{
										id: this.props.emco_region_ID,
										location_title: this.props.location_title,
										id_prod: this.props.id_prod,
										"id_dev-istrain": this.props["id_dev-istrain"],
										id_dev: e.target.value
									},
									"id_dev"
								)
							}
						/>
					</td>
					<td>
						<Button
							onClick={() =>
								this.props.remove_region(
									this.props.emco_region_table_row_index,
									this.props.emco_region_ID
								)
							}
							color="primary"
						>
							<i class="fa fa-window-close fa-2x" aria-hidden="true" />
						</Button>
					</td>
				</tr>
			</React.Fragment>
		);
	}
}

const mapStateToProps = state => ({
	API_URL: state.APIUrl
});

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(Emco_Region_Table_Row);
